import React, {
    HTMLAttributes, ReactElement, ReactNode,
} from "react";
import { ExtractParams, PathValues } from "../../../contexts/Routing";
import useTableData, { ContainsId } from "./base";

export interface TableRowActionProps<
    T, TPath extends PathValues = PathValues
> extends Omit<HTMLAttributes<HTMLTableCellElement>, "children" | "onClick"> {
    altText: string;
    icon: ReactNode;
    canClick?: (item: T) => boolean | undefined;
    isDisabled?: (item: T) => boolean | undefined;
    onClick?: (item: T) => void;
    to?: TPath;
    getLinkParams?: (item: T) => ExtractParams<TPath>;
    metricPath?: string[];
    getUrl?: (item: T) => string;
    isNewTab?: boolean;
}

function TableRowAction<T extends ContainsId, TPath extends PathValues = PathValues>(
    args: TableRowActionProps<T, TPath>,
): ReactNode {
    const {
        altText,
        icon,
        onClick,
        canClick,
        isDisabled,
        to: link,
        getLinkParams,
        getUrl,
        isNewTab,
        metricPath,
    } = args;

    const data = useTableData<T>();
    data.useColumnAction({
        altText,
        icon,
        onClick,
        canClick,
        isDisabled,
        link,
        getLinkParams,
        getUrl,
        isNewTab,
        metricPath,
    });

    return null;
}

TableRowAction.defaultProps = {
    canSort: false,
    canFilter: false,
};

export type TableRowActionType<T> = <TPath extends PathValues = PathValues>(
    props: TableRowActionProps<T, TPath> & { ref?: React.ForwardedRef<HTMLTableCellElement> }
) => ReactElement;

export default TableRowAction as TableRowActionType<unknown>;
